import React from 'react'
import ProjectStep from "../components/ProjectStep";
import JobPositionPanel from "../../talent-job-board/components/JobPositionPanel";
import ProjectPosition from "../../../models/ProjectPosition";

export default class PostsOnJobBoardStep extends ProjectStep {

    static TranslationKey = 'posts_on_job_board_step';

    static path = '/post-on-wripple-job-board';

    static slug = 'post-on-wripple-job-board';

    static sectionName = 'Post To Wripple Job Board';
    static ValidationMethodName = 'validatePostsOnJobBoard';


    constructor(props, context) {
        super(props, context);

        let samplePosition = TB.first(this.props.project.sortedPositions());
        this.state = {
            job: ProjectPosition.make({
                ...samplePosition,
                is_match:true,
                has_shown_interest_in_job: false,
                can_show_interest_in_job: true,
                posted_at: new Date().toISOString(),
                estimated_payout: samplePosition.platform_cost,
                is_new: true,
                project: this.props.project,
                client: {
                    ...(context?.auth?.clientOrg() || {})
                }})
        }
    }

    static hasCompleted(project) {

        return project.validatePostsOnJobBoard();
    }

    /**
     * @param {Project} project
     * @returns {Object}
     */
    static reviewMapping(project) {


        return {
            [this.Trans('job_board_review_header')]: {
                [this.Trans('job_board_review_label')]: project.posts_on_talent_job_board ? 'Yes' : 'No'
            }
        }
    }


    /**
     * The fields mapping for the form
     */
    formFields = () => {

        return [
            {
                fields: {
                    post_to_job_board_label: (
                        <label className="col-form-label">
                            {this.translate("job_board_question")}
                        </label>
                    ),
                    posts_on_talent_job_board: {
                        label: this.translate("job_board_checkbox_label"),
                        type: 'checkbox',
                        required: false
                    },
                    post_to_job_board_divider: (
                        <hr/>
                    ),
                    previewText: (
                        <div className="my-3">
                            {this.translate("job_board_info_header").length > 0 && (
                                <h5 className="mb-2"><b>{this.translate("job_board_info_header")}</b></h5>
                            )}
                            <p>{this.translate("job_board_info_content")}</p>
                        </div>
                    ),
                    preview: (
                        <div style={{maxWidth: 400}} className="mt-2 mx-auto">
                            <JobPositionPanel job={this.state.job} preview/>
                        </div>
                    )
                }
            },
        ]
    };
}